import { atom, atomFamily, selectorFamily, selector } from "recoil";

export const connectionUrl = atom<string>({
    key: "web3/connectionUrl",
    default : process.env.REACT_APP_SOL_RPC!
})